import { render } from "./VariablesButton.vue?vue&type=template&id=a5f704e8"
import script from "./VariablesButton.vue?vue&type=script&lang=ts"
export * from "./VariablesButton.vue?vue&type=script&lang=ts"

import "./VariablesButton.vue?vue&type=style&index=0&id=a5f704e8&lang=css"
script.render = render

export default script